import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-profile-v2',
  imports: [RouterOutlet],
  templateUrl: './profile-v2.component.html',
  styleUrl: './profile-v2.component.scss'
})
export class ProfileV2Component {}
